export const RESET_REQUEST_COPY = "If an account exists for that email, a reset code is on its way.";
export const LOGIN_FAILURE_COPY = "Email or password is incorrect.";
export const RESET_RETRY_COPY = "Could not send a reset code right now. Try again.";

const COPY: Record<string, string> = {
  NotAuthorizedException: LOGIN_FAILURE_COPY,
  UserNotConfirmedException: LOGIN_FAILURE_COPY,
  UsernameExistsException: "An account already uses this email. Log in or reset your password.",
  CodeMismatchException: "That code is not correct. Check it and try again.",
  ExpiredCodeException: "That code expired. Request a new one.",
  InvalidPasswordException: "Use at least eight characters with a number and an uppercase letter.",
  LimitExceededException: "Too many attempts. Wait a moment and try again.",
};

export const authErrorCopy = (cause: unknown) =>
  cause instanceof Error && COPY[cause.name] ? COPY[cause.name] : "Something went wrong. Try again.";

export const isPrivateResetFailure = (cause: unknown) =>
  cause instanceof Error && cause.name === "UserNotFoundException";
export const isPrivateConfirmationFailure = (cause: unknown) =>
  cause instanceof Error &&
  ["UserNotFoundException", "NotAuthorizedException", "InvalidParameterException"].includes(cause.name);
